export const ChangeRouting = [
  {
    path: "/purchase/change/list",
    name: "purchase-change-list",
    meta: { title: "采购合同变更" },
    notice: { type: "purchase_contract_change_examine", hasNotice: false },
    component: () =>
      import(/* webpackChunkName: "purchase-change" */ "@/views/purchase/change/list/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/change/create",
    name: "purchase-change-create",
    meta: { title: "新增采购合同变更", comName:"PurchaseChangeFormCreate" },
    component: () =>
      import(/* webpackChunkName: "purchase-change" */ "@/views/purchase/change/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/change/edit/:id",
    name: "purchase-change-edit",
    meta: { title: "编辑采购合同变更", comName:"PurchaseChangeFormCreate" },
    component: () =>
      import(/* webpackChunkName: "purchase-change" */ "@/views/purchase/change/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/change/detail/:id",
    name: "purchase-change-detail",
    meta: { title: "采购合同变更详情" },
    component: () =>
      import(/* webpackChunkName: "purchase-change" */ "@/views/purchase/change/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/change/flowPrint/:id",
    name: "purchase-change-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/purchase/change/flow-print/index.vue"
      ),
  },
];
